
export default {
    data() {
        return {}
    },
}
